(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const titlesSwiper = new Swiper('.titles-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      allowTouchMove: false,
    });
  
    const reviewsSwiper = new Swiper('.reviews-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 25,
          slidesOffsetBefore: 25,
          slidesOffsetAfter: 25,
        }
      },
      navigation: {
        prevEl: '.reviews-swiper-button-prev',
        nextEl: '.reviews-swiper-button-next',
      }
    });

    const setTitlesSwiper = (reviewSlide) => {
      console.log(reviewSlide);
  
      if (reviewSlide.dataset.reviewType === 'amazon') {
        titlesSwiper.slideTo(0, 300);
      } else if (reviewSlide.dataset.reviewType === 'ig') {
        titlesSwiper.slideTo(1, 300);
      } else {
        titlesSwiper.slideTo(2, 300);
      }
    }

    reviewsSwiper.on('slideChange', () => setTitlesSwiper(reviewsSwiper.slides[reviewsSwiper.activeIndex]));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.best-sellers__swiper', {
      direction: 'horizontal',
      slidesPerView: 1.9,
      slidesPerGroup: 1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: false,
      breakpoints: {
        750: {
          slidesPerView: 4,
          centeredSlides: false,
          spaceBetween: 30,
          slidesOffsetBefore: 30,
          slidesOffsetAfter: 30,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: false,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.blog__swiper', {
      direction: 'horizontal',
      slidesPerView: 1.20,
      slidesPerGroup: 1,
      spaceBetween: 10,
      centeredSlides: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 40,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: false,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const titlesSwiper = new Swiper('.titles-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      allowTouchMove: false,
    });
  
    const reviewsSwiper = new Swiper('.reviews-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 40,
          slidesOffsetBefore: 35,
          slidesOffsetAfter: 35,
        }
      },
      navigation: {
        prevEl: '.reviews-swiper-button-prev',
        nextEl: '.reviews-swiper-button-next',
      }
    });

    const setTitlesSwiper = (reviewSlide) => {
      console.log(reviewSlide);
  
      if (reviewSlide.dataset.reviewType === 'amazon') {
        titlesSwiper.slideTo(0, 300);
      } else if (reviewSlide.dataset.reviewType === 'ig') {
        titlesSwiper.slideTo(1, 300);
      } else {
        titlesSwiper.slideTo(2, 300);
      }
    }

    reviewsSwiper.on('slideChange', () => setTitlesSwiper(reviewsSwiper.slides[reviewsSwiper.activeIndex]));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-objective-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.single-objective__swiper', {
      direction: 'horizontal',
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      spaceBetween: 10,
      centeredSlides: true,
      breakpoints: {
        750: {
          slidesPerView: 4,
          centeredSlides: false,
          spaceBetween: 30,
        },
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
        addIcons: false,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => { // Changed to 'load' to ensure everything is ready
    const swiper = new Swiper('#videos-slider', {
      a11y: false, // Turn off completely to stop Swiper's own focus logic
      direction: 'horizontal',
      slidesPerView: 1.5,
      spaceBetween: 10,
      centeredSlides: true,
      watchSlidesProgress: true,
      preventClicks: false, 
      preventClicksPropagation: false,
      loop: true,
      breakpoints: {
        750: {
          slidesPerView: 4,
          centeredSlides: false,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    document.querySelectorAll('.video-overlay').forEach(overlay => {
      overlay.addEventListener('click', (e) => {
        const wrapper = e.currentTarget.closest('.video-wrapper');
        const video = wrapper.querySelector('video');

        if (video.paused) {
          video.play();
          wrapper.classList.add('is-playing');
        } else {
          video.pause();
          wrapper.classList.remove('is-playing');
        }
      });
    });

    // Also toggle UI if video is clicked directly or ends
    document.querySelectorAll('video').forEach(video => {
      video.addEventListener('ended', () => {
        video.closest('.video-wrapper').classList.remove('is-playing');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
